export enum Font {
    Inter = "'InterVariable', sans-serif",
    SpaceGrotesk = "'Space GroteskVariable', sans-serif",
    UbuntuMono = "'Ubuntu Mono', monospace",
}
